import React from 'react';
import { Layout, Typography } from 'antd';
import SchemaBuilder from './components/SchemaBuilder';

const App: React.FC = () => (
  <Layout style={{ minHeight: '100vh', padding: 24 }}>
    <Typography.Title>JSON Schema Builder</Typography.Title>
    <SchemaBuilder />
  </Layout>
);

export default App;
